export default "__VITE_ASSET__Cflk723U__"